<app-header
  icon="fas fa-bar-chart"
  text="Diagrammstandards"
  sub="Definieren Sie die Grundeinstellungen Ihrer Diagramme."></app-header>
<p-divider />
<div class="grid">
  <div class="col-12">
    <p-panel [styleClass]="'mb-3'">
      <ng-template pTemplate="header">
        <h4 class="flex align-items-center gap-3 m-0">
          <i class="fas fa-chart-column"></i> Balken- und Säulendiagramme
        </h4>
      </ng-template>
      <app-configuration-chart-bar></app-configuration-chart-bar>
    </p-panel>
  </div>
  <div class="col-12">
    <p-panel [styleClass]="'mb-3'">
      <ng-template pTemplate="header">
        <h4 class="flex align-items-center gap-3 m-0">
          <i class="fas fa-arrow-up-right-dots"></i> Streudiagramme
        </h4>
      </ng-template>
      <app-configuration-chart-scatter></app-configuration-chart-scatter>
    </p-panel>
  </div>
  <div class="col-12">
    <p-panel [styleClass]="'mb-3'">
      <ng-template pTemplate="header">
        <h4 class="flex align-items-center gap-3 m-0">
          <i class="fas fa-line-chart"></i> Liniendiagramme
        </h4>
      </ng-template>
      <app-configuration-chart-line></app-configuration-chart-line>
    </p-panel>
  </div>
  <div class="col-12">
    <p-panel [styleClass]="'mb-3'" header="Kreisdiagramme">
      <ng-template pTemplate="header">
        <h4 class="flex align-items-center gap-3 m-0">
          <i class="fas fa-pie-chart"></i> Kreisdiagramme
        </h4>
      </ng-template>
      <app-configuration-chart-pie></app-configuration-chart-pie>
    </p-panel>
  </div>
  <div class="col-12">
    <p-panel [styleClass]="'mb-3'">
      <ng-template pTemplate="header">
        <h4 class="flex align-items-center gap-3 m-0">
          <i class="fas fa-snowflake"></i> Polardiagramme
        </h4>
      </ng-template>
      <app-configuration-chart-polar></app-configuration-chart-polar>
    </p-panel>
  </div>
  <div class="col-12">
    <p-panel [styleClass]="'mb-3'">
      <ng-template pTemplate="header">
        <h4 class="flex align-items-center gap-3 m-0">
          <i class="fas fa-satellite-dish"></i> Radardiagramme
        </h4>
      </ng-template>
      <app-configuration-chart-radar></app-configuration-chart-radar>
    </p-panel>
  </div>
  <div class="col-12">
    <p-panel [styleClass]="'mb-3'">
      <ng-template pTemplate="header">
        <h4 class="flex align-items-center gap-3 m-0">
          <i class="fas fa-table"></i> Tabellen
        </h4>
      </ng-template>
      <app-configuration-chart-table></app-configuration-chart-table>
    </p-panel>
  </div>
</div>
